import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Sankey, ResponsiveContainer, Tooltip } from 'recharts';
import CustomTooltip from '../../CustomTooltip';
import SankeyChartNode from './SankeyChartNode';
import { getSankeyChartMargin } from '../../../dashboardUtils';

function SankeyChart(props) {
    const {
        responsiveContainerProperties,
        suffix = '',
        timeFormat = '',
    } = props.chartProperties;

    const margin = getSankeyChartMargin(
        props.dataPoints,
        props.dataFormatter,
        timeFormat,
        suffix
    );

    return (
        <ResponsiveContainer {...responsiveContainerProperties}>
            <Sankey
                data={props.dataPoints}
                node={
                    <SankeyChartNode
                        dataFormat={timeFormat}
                        dataFormatter={props.dataFormatter}
                        suffix={suffix}
                    />
                }
                margin={margin}
                nodePadding={30}
                iterations={0}
            >
                <Tooltip
                    cursor={props.dataPoints.length !== 0}
                    content={
                        <CustomTooltip
                            activeIndex={0}
                            axisKey="name"
                            dataFormat={timeFormat}
                            dataFormatter={props.dataFormatter}
                            showSinglePoint={true}
                            suffix={suffix}
                        />
                    }
                />
            </Sankey>
        </ResponsiveContainer>
    );
}

SankeyChart.propTypes = {
    chartProperties: PropTypes.shape({
        responsiveContainerProperties: PropTypes.instanceOf(Object),
        suffix: PropTypes.string,
        timeFormat: PropTypes.string,
    }).isRequired,
    dataFormat: PropTypes.string,
    dataFormatter: PropTypes.func,
    dataPoints: PropTypes.instanceOf(Object).isRequired,
    groupLabels: PropTypes.instanceOf(Array),
    legendFormatter: PropTypes.func.isRequired,
};

export default React.memo(SankeyChart, (prevProps, nextProps) =>
    _.isEqual(prevProps.dataPoints, nextProps.dataPoints)
);
